import { useIntl } from "react-intl";

import { ExpandableSection } from "@/components/ExpandableSection/ExpandableSection";

export function AdditionalInfoCard() {
  const intl = useIntl();

  return (
    <>
      <div className="section-title mt-4">
        {intl.formatMessage({
          defaultMessage: "Additional Info",
          description: "Section heading for supplementary flight information",
        })}
      </div>
      <div className="section-card mt-2">
        <ExpandableSection>
          <div className="flex w-full flex-col gap-2">
            <h3 className="text-sm font-medium text-text-primary">
              {intl.formatMessage({
                defaultMessage: "Regulations on Special Baggage Allowance",
                description:
                  "Section heading for special baggage regulations (sports equipment, musical instruments, etc.)",
              })}
            </h3>
            <p className="text-sm font-normal text-text-primary">
              {intl.formatMessage({
                defaultMessage:
                  "Each airline has different regulations on special baggage (such as musical instruments, sports equipment, etc.). Therefore, for baggage other than regular backpacks and suitcases, we recommend checking the baggage regulations on the airline's website or contacting our customer support before traveling.",
                description:
                  "Informational paragraph about special baggage regulations and airline-specific rules",
              })}
            </p>
          </div>
        </ExpandableSection>
      </div>
    </>
  );
}
